<template>
  <v-card id="edit-volume-promotion">
    <flewid-dialog
      draggable
      scrollable
      persistent
      content-class="i-dialog"
      v-model="unsavedTiersDialog"
      width="500"
    >
      <v-card>
        <template>
          <v-card-title class="i-dialog-header-div">
            <span class="g-heading-m g-bold">Warning</span>
          </v-card-title>

          <v-card-text class="i-dialog-content-div py-4">
            <div class="my-4 text-center">
              <p>
                <strong
                  >You have {{ unsavedTiersQuantity }} unsaved Volume
                  Tiers</strong
                >
              </p>
              <p>
                Would you like to proceed
                {{ newPromotion ? 'Creating' : 'Saving' }} this Volume Buy?
              </p>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="i-dialog-actions-div pt-6 justify-end">
            <v-btn
              rounded
              text
              class="i-btn-text-black"
              @click="unsavedTiersDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              rounded
              class="i-btn-block-secondary mr-4"
              @click="confirmSaveVolumePromotion"
              >Confirm</v-btn
            >
          </v-card-actions>
        </template>
      </v-card>
    </flewid-dialog>

    <v-card-title class="i-card-title-div">
      <v-row class="align-center">
        <v-col cols="12" sm="9">
          <span class="g-bold g-heading-l">{{
            newPromotion ? 'New Volume Buy' : 'Edit Volume Buy'
          }}</span>
        </v-col>
        <v-col cols="12" sm="3">
          <i-instructions
            instructionKey="data-maintenance/volume-buys/add-dialog"
          ></i-instructions>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="py-8 i-card-content-div">
      <v-form @submit.prevent>
        <template v-if="!newPromotion && volumePromotion.approval">
          <v-alert
            v-if="volumePromotion.approval.status === 'REJECTED'"
            border="left"
            class="i-alert"
            color="warning"
            dense
            elevation="1"
            outlined
            text
            type="error"
          >
            <div class="font-weight-bold mb-3">
              Your Volume Buy requires the following changes to be made:
            </div>
            <div>
              <pre class="i-approval-message">{{
                volumePromotion.approval.message
              }}</pre>
            </div>
          </v-alert>
        </template>

        <v-alert
          v-if="!newPromotion"
          border="left"
          dense
          text
          outlined
          type="info"
          elevation="1"
          class="i-alert"
        >
          <span v-if="activePromotion"
            >For Active Volume Buys only the End Date can be edited</span
          >
          <span v-else
            >For Upcoming Volume Buys only Volume Buy Name, Date Range, adding
            or removing pre-selected Target Types & Volume Buy Pricing in Zones
            & Carton Tiers can be edited</span
          >
        </v-alert>

        <p class="g-bold g-heading-s g-text-color-black">Volume Buy Type</p>
        <legacy-radio-group
          :disabled="!newPromotion"
          name="edit-volume-promotion-type"
          :default-col-props="{ cols: '12', md: '4', class: 'pb-0' }"
          :options="[
            { label: 'By Family Group', value: FAMILY_GROUP },
            {
              label: 'By Product (Live products only)',
              value: SINGLE_PRODUCT
            }
          ]"
          v-model="promotionType"
          @change="resetPromotionForm"
        />

        <template v-if="familyPromotion">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            Family Group
          </p>
          <v-text-field
            v-if="activePromotion"
            background-color="#0000000f"
            class="mt-4"
            dense
            disabled
            :value="lockedFamilyGroupLabel"
            label="Select Family Group *"
            outlined
          ></v-text-field>
          <v-autocomplete
            v-else
            attach
            background-color="#0000000f"
            class="mt-4"
            clearable
            dense
            :disabled="!newPromotion"
            :items="listFamilyGroups"
            item-disabled="disabled"
            label="Select Family Group *"
            outlined
            v-model="selectedFamilyGroup"
            :rules="[(v) => !!v || 'Family Group selection required']"
            small-chips
            @change="handleFamilyGroupSelection"
          >
            <template v-slot:selection>
              <v-tooltip
                bottom
                content-class="family-tooltip"
                transition="fade-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-bind="attrs" v-on="on" small class="ma-1" outlined>
                    {{ selectedFamilyGroupLabel }}
                  </v-chip>
                </template>

                <div class="tooltip-content">
                  <strong>Products in this Family Group:</strong>
                  <ul>
                    <li
                      v-for="(productName, idx) in getFamilyGroupProductsById(
                        selectedFamilyGroup
                      )"
                      :key="idx"
                    >
                      {{ productName }}
                    </li>
                  </ul>
                </div>
              </v-tooltip>
            </template>
          </v-autocomplete>
          <v-alert
            v-if="showUnavailableProductAlert"
            border="left"
            dense
            text
            outlined
            type="warning"
            elevation="1"
            class="mt-3 i-alert"
          >
            {{ upcomingPriceChangeWarningText }}
          </v-alert>
        </template>

        <template v-if="productPromotion">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            Product
          </p>
          <v-text-field
            v-if="activePromotion"
            background-color="#0000000f"
            class="mt-4"
            dense
            disabled
            :value="lockedProductLabel"
            label="Select Product *"
            outlined
          ></v-text-field>
          <v-autocomplete
            v-else
            attach
            background-color="#0000000f"
            class="mt-4"
            clearable
            dense
            :disabled="!newPromotion"
            :items="visibleProducts"
            item-title="text"
            item-text="text"
            item-value="value"
            item-disabled="disabled"
            :loading="productsLoading"
            :no-data-text="
              productsLoading ? 'Loading products...' : 'No data available'
            "
            label="Select Product *"
            outlined
            :rules="[(v) => !!v || 'Product selection required']"
            v-model:search-input="productSearchInput"
            small-chips
            v-model="selectedProduct"
            @focus="$emit('ensure-products')"
            @click:clear="clearSelectedProduct"
            @change="handleProductChange"
          >
            <template v-slot:selection>
              {{ selectedProductLabel }}
            </template>
          </v-autocomplete>
          <v-alert
            v-if="showUnavailableProductAlert"
            border="left"
            dense
            text
            outlined
            type="warning"
            elevation="1"
            class="mt-3 i-alert"
          >
            {{ upcomingPriceChangeWarningText }}
          </v-alert>
        </template>

        <p class="g-bold g-heading-s g-text-color-black mt-2 mt-md-4 mb-3">
          Volume Buy Name
          <v-icon
            class="i-tooltip-color pb-1"
            small
            v-tooltip="'Change name if required'"
          >
            mdi-help-circle-outline
          </v-icon>
        </p>
        <v-alert
          border="left"
          dense
          text
          outlined
          type="info"
          elevation="1"
          class="i-alert"
          v-if="!activePromotion"
        >
          <ul>
            <li>Name needs to be representative of the Volume Buy</li>
            <li>
              It will be displayed in the
              {{ isILR ? 'Customer(s)' : 'Retailer(s)' }} Marketplace
            </li>
          </ul>
        </v-alert>

        <v-text-field
          outlined
          background-color="#0000000f"
          dense
          v-model="promotionName"
          label="Volume Buy Name *"
          :disabled="
            activePromotion || !(selectedProduct || selectedFamilyGroup)
          "
          :rules="[
            (v) => !!v || 'Volume Buy Name is required',
            (v) =>
              (!!v && v.length <= 60) ||
              'Volume Buy Name cannot exceed 60 characters'
          ]"
        >
        </v-text-field>

        <p class="g-bold g-heading-s g-text-color-black mt-2 mt-md-4">
          Volume Buy Date Range
          <v-icon
            class="i-tooltip-color pb-1"
            small
            v-tooltip="
              'Starts at 12:00am & Ends at 11:59pm on the submitted dates'
            "
          >
            mdi-help-circle-outline
          </v-icon>
        </p>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="15"
              :nudge-top="30"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  append-icon="mdi-calendar"
                  background-color="#0000000f"
                  class="mt-0"
                  dense
                  label="Start Date *"
                  outlined
                  readonly
                  v-on="on"
                  v-model="startDateDisplay"
                  :disabled="!canEditStartDate"
                  :rules="[
                    (v) => !!v || 'Start Date required',
                    validStartSate(startDate, endDate)
                  ]"
                ></v-text-field>
              </template>
              <v-date-picker
                :min="minAllowedStartDate"
                v-model="startDate"
                @change="startDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="15"
              :nudge-top="30"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  append-icon="mdi-calendar"
                  background-color="#0000000f"
                  dense
                  :disabled="!canEditEndDate"
                  label="End Date *"
                  outlined
                  readonly
                  :rules="[
                    (v) => !!v || 'End Date required',
                    validEndDate(startDate, endDate)
                  ]"
                  v-on="on"
                  v-model="endDateDisplay"
                ></v-text-field>
              </template>
              <v-date-picker
                :min="minAllowedEndDate"
                :picker-date="minAllowedEndDate.slice(0, 7)"
                v-model="endDate"
                @change="endDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <p class="g-bold g-heading-s g-text-color-black mt-2">Target Type</p>
        <legacy-radio-group
          :disabled="!newPromotion"
          name="edit-volume-promotion-target-type"
          :default-col-props="{ cols: '12', md: '4', class: 'pb-0' }"
          :options="[
            { label: 'All Zones', value: NATIONAL },
            { label: 'Banner Group(s)', value: BANNER_GROUP },
            {
              label: 'Multi-Store Operator(s)',
              value: MULTI_STORE_OPERATOR
            },
            {
              label: isILR ? 'Customer(s)' : 'Retailer(s)',
              value: RETAILER_STORE
            }
          ]"
          v-model="targetType"
          @change="resetTargetTypeForm"
        />

        <template v-if="targetType === BANNER_GROUP">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            Banner Group
          </p>
          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-4 mb-6"
            clearable
            deletable-chips
            dense
            :disabled="activePromotion"
            :items="targetBannerGroups"
            label="Select Banner Group(s)"
            multiple
            outlined
            :rules="[(v) => !!v.length || '']"
            v-model:search-input="searchInput"
            small-chips
            v-model="targetBannerGroupIds"
            @change="searchInput = ''"
          ></v-autocomplete>
        </template>

        <template v-if="targetType === MULTI_STORE_OPERATOR">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            Multi-Store Operator
          </p>
          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-3 mb-6"
            clearable
            deletable-chips
            dense
            :disabled="activePromotion"
            :items="targetMultiStoreOperators"
            label="Select Multi-Store Operator(s)"
            multiple
            outlined
            :rules="[(v) => !!v.length || '']"
            v-model:search-input="searchInput"
            small-chips
            v-model="targetMultiStoreOperatorIds"
            @change="searchInput = ''"
          ></v-autocomplete>
        </template>

        <template v-if="targetType === RETAILER_STORE">
          <p class="g-bold g-heading-s g-text-color-black mt-3 mt-md-5">
            {{ isILR ? 'Customer(s)' : 'Retailer(s)' }}
          </p>
          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-3 mb-9"
            clearable
            deletable-chips
            dense
            :disabled="activePromotion"
            hide-details
            :items="targetStores"
            :label="`Select ${isILR ? 'Customer(s)' : 'Retailer(s)'}`"
            :item-disabled="savedListApplied ? () => true : () => false"
            multiple
            outlined
            :rules="[(v) => !!v.length || ``]"
            v-model:search-input="searchInput"
            small-chips
            v-model="targetStoreIds"
            @change="searchInput = ''"
            @click:clear="resetRetailers"
          ></v-autocomplete>
          <retailer-list-action-button
            class="mb-2"
            :supplier-id="selectedSupplierId"
            :selected-retailers="targetStoreIds"
            :disabled="activePromotion"
            mode="useOnly"
            @apply="handleApplySavedRetailers"
            :saved-list-applied="savedListApplied"
          />
        </template>

        <p
          v-if="isUsTenant"
          class="g-bold g-heading-s g-text-color-black mt-2 mt-md-4"
        >
          Search State (Optional)
        </p>
        <i-search-post-code v-if="!isUsTenant" dense />
        <v-text-field
          v-if="isUsTenant"
          v-model="zoneFilter"
          dense
          outlined
          clearable
          class="mt-3"
          label="Search State"
          hint="Type state code or state name"
          persistent-hint
        />

        <p
          class="g-bold g-heading-s g-text-color-black mt-2 mt-md-4 mb-2 mb-md-4"
        >
          Volume Buys by {{ isUsTenant ? 'State' : 'Zone' }} & Carton Tier
        </p>
        <legacy-radio-group
          v-if="validPromotionSelection"
          v-model="discountEntryMode"
          name="volume-buy-discount-entry-mode"
          :options="discountEntryModeOptions"
          :disabled="activePromotion"
          :default-col-props="{ cols: '12', sm: '3', class: 'py-0' }"
          class="mt-3 mb-2"
        />
        <v-alert
          v-if="!validPromotionSelection"
          border="left"
          dense
          text
          outlined
          type="info"
          elevation="1"
          class="mt-4 i-alert"
        >
          <span>Select a Volume Family Group or a single Product first</span>
        </v-alert>

        <v-alert
          v-if="validPromotionSelection && !activePromotion"
          border="left"
          outlined
          dense
          text
          type="info"
          elevation="1"
          class="mt-3 i-alert"
        >
          For {{ isUsTenant ? 'States' : 'Zones' }} without promotions, leave
          blank
        </v-alert>

        <v-alert
          v-if="validPromotionSelection && !hasValidTierForUpdate"
          border="left"
          dense
          outlined
          text
          type="error"
          elevation="1"
          class="mt-4 i-alert"
        >
          <span>
            At least 1 {{ isUsTenant ? 'state' : 'zone' }} with valid pricing is
            required
          </span>
        </v-alert>

        <v-alert
          v-if="hasUnsavedTiers && hasValidTierForUpdate"
          border="left"
          dense
          outlined
          text
          type="warning"
          elevation="1"
          class="mb-2 i-alert"
        >
          <span
            >Warning – This Promotion has Volume Tiers that have not been added
            yet</span
          >
        </v-alert>
        <update-price-to-all-zones
          mode="volumeBuy"
          :disabled="bulkZoneUpdatesDisabled"
          :hide-unit-rrp="isServiceProductSelected || isUsTenant"
          :is-service-product="isServiceProductSelected"
          v-model:discount-entry-mode="discountEntryMode"
          @update-carton="onUpdateAmountOff"
          @update-discount-percentage="onUpdateDiscountPercentage"
          @update-rrp="onUpdateUnitRrp"
          @update-cartons="onUpdateCartons"
          @add-all-tiers="addAllTiers"
          ref="updateAllZones"
        />

        <volume-buy-tiers-table
          :selected-product="selectedProduct"
          :selected-family-group="selectedFamilyGroup"
          :hasGst="hasGst"
          :hasWet="hasWet"
          :products="products"
          :zone-prices="filteredZonePrices"
          :variable-weight-target-in-kg="variableWeightTargetInKg"
          :package-quantity="packageQuantity"
          :active-promotion="activePromotion"
          :isZoneNewTierValid="isZoneNewTierValid"
          :is-service-product="isServiceProductSelected"
          :discount-entry-mode="discountEntryMode"
          ref="volumeTiersRef"
          @tier-added="handleTierAdded"
        />
      </v-form>
    </v-card-text>

    <v-card-actions class="i-dialog-actions-div pt-6 justify-end">
      <v-btn rounded text class="i-btn-text-black" @click="$emit('cancel')"
        >Cancel</v-btn
      >
      <v-btn
        rounded
        class="i-btn-block-secondary mr-4"
        :disabled="!validPromotion"
        :loading="saving"
        @click="handleSaveVolumePromotion"
        >{{ newPromotion ? 'Create' : 'Update' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import iInstructions from '@/components/Instructions'
import { mapActions, mapState, mapGetters } from 'vuex'
import {
  createVolumePromotion,
  updateVolumePromotion
} from '@/services/volumePromotions'
import LegacyRadioGroup from '@/components/LegacyRadioGroup.vue'
import FieldValidators from '@/utils/FieldValidators'
import iSearchPostCode from '@/components/SearchPostCode'
import FlewidDialog from '@/components/FlewidDialog'
import VolumePromotionHelper, {
  DEFAULT_PROMOTION_TIER
} from '@/modules/dataMaintenance/helper/VolumePromotionHelper'
import {
  minAllowedPromotionEndDate,
  minAllowedPromotionStartDate
} from '@/modules/dataMaintenance/helper/PromotionPublishSchedule'
import VolumeBuyTiersTable from '@/modules/dataMaintenance/components/VolumeBuyTiersTable'
import RetailerListActionButton from '@/components/RetailerListActionButton.vue'
import UpdatePriceToAllZones from '@/components/UpdatePriceToAllZones.vue'
import { buildCountryDisplayRules } from '@/utils/countryDisplay'
import { formatRegionDisplayName } from '@/utils/stateDisplay'
import { buildVisibleProductOptions } from '@/modules/dataMaintenance/helper/ProductAutocompleteHelper'
import {
  buildUpcomingPriceChangeProductCodeSet,
  familyGroupHasUpcomingPriceChange,
  productHasUpcomingPriceChange,
  UPCOMING_PRICE_CHANGE_WARNING_TEXT,
  withUpcomingPriceChangeDisabled
} from '@/modules/dataMaintenance/helper/PromotionProductAvailabilityHelper'
import {
  amountOffFromDiscountPercentage,
  DISCOUNT_ENTRY_MODE,
  setDiscountPercentageFromAmountOff
} from '@/modules/dataMaintenance/helper/DiscountEntryHelper'

const PROMOTION_FIELDS = {
  selectedFamilyGroup: null,
  selectedProduct: null,
  endDate: null,
  startDate: null,
  promotionName: null,
  targetType: null,
  targetBannerGroupIds: [],
  targetMultiStoreOperatorIds: [],
  targetStoreIds: [],
  zonePrices: [],
  hasGst: null,
  hasWet: null,
  packageQuantity: null,
  variableWeightTargetInKg: null
}

const PROMOTION_TYPE = {
  FAMILY_GROUP: 'FAMILY_GROUP',
  SINGLE_PRODUCT: 'SINGLE_PRODUCT'
}

const TARGET_TYPE = {
  BANNER_GROUP: 'BANNER_GROUP',
  MULTI_STORE_OPERATOR: 'MULTI_STORE_OPERATOR',
  RETAILER_STORE: 'RETAILER_STORE',
  NATIONAL: 'NATIONAL'
}

export default {
  components: {
    LegacyRadioGroup,
    iInstructions,
    VolumeBuyTiersTable,
    FlewidDialog,
    iSearchPostCode,
    RetailerListActionButton,
    UpdatePriceToAllZones
  },

  data: () => ({
    unsavedTiersDialog: false,
    initialObject: {},
    newTier: { ...DEFAULT_PROMOTION_TIER },
    calculatingGPP: false,
    endDateMenu: false,
    startDateMenu: false,
    searchInput: '',
    productSearchInput: '',
    selectedProductSnapshot: null,
    zoneFilter: '',
    promotionType: null,
    discountEntryMode: DISCOUNT_ENTRY_MODE.AMOUNT,
    originalVolumePromotion: {},
    saving: false,
    savedListApplied: false,
    targetBannerGroups: [],
    targetMultiStoreOperators: [],
    ...FieldValidators,
    ...PROMOTION_FIELDS,
    ...PROMOTION_TYPE,
    ...TARGET_TYPE,
    upcomingPriceChangeWarningText: UPCOMING_PRICE_CHANGE_WARNING_TEXT
  }),

  props: {
    familyGroups: Array,
    pricingRegions: Array,
    products: Array,
    productsLoading: Boolean,
    volumePromotion: Object
  },

  mounted() {
    this.mapBannerGroupsList()
    this.mapMultiStoreOperatorsList()
    this.mapStoresList()
    if (this.newPromotion) {
      this.targetType = this.NATIONAL
    } else {
      this.copyVolumePromotion()
    }
    // Create blue print of volume promo so that we can know if changes were made
    this.originalVolumePromotion = _.cloneDeep(this.createBluePrint())
  },

  computed: {
    ...mapState('preferences', ['selectedSupplierId']),
    ...mapState('multiStoreOperators', ['multiStoreOperators']),
    ...mapState('bannerGroups', ['bannerGroups']),
    ...mapState('stores', ['retailerStores']),
    ...mapGetters('tenant', ['isILR', 'tenantCountryRegion']),

    discountEntryModeOptions() {
      return [
        { label: 'Amount', value: DISCOUNT_ENTRY_MODE.AMOUNT },
        { label: '% Discount', value: DISCOUNT_ENTRY_MODE.PERCENTAGE }
      ]
    },

    activePromotion() {
      return (
        this.volumePromotion?.active || this.volumePromotion?.isEndDateAmendment
      )
    },
    hasRequestedAmendment() {
      return this.volumePromotion?.approval?.status === 'REJECTED'
    },
    canEditStartDate() {
      return (
        !!(this.selectedProduct || this.selectedFamilyGroup) &&
        (!this.activePromotion ||
          (this.hasRequestedAmendment &&
            !this.volumePromotion?.isEndDateAmendment))
      )
    },
    canEditEndDate() {
      return !!(this.selectedProduct || this.selectedFamilyGroup)
    },

    changesMade() {
      return !_.isEqual(this.originalVolumePromotion, this.createBluePrint())
    },

    familyPromotion() {
      return this.promotionType === this.FAMILY_GROUP
    },

    productPromotion() {
      return this.promotionType === this.SINGLE_PRODUCT
    },

    newPromotion() {
      return _.isEmpty(this.volumePromotion)
    },

    bulkZoneUpdatesDisabled() {
      return !this.newPromotion
    },

    beforeEndDate() {
      return this.startDate <= this.endDate
    },

    endDateDisplay() {
      return this.$options.filters.formatDatePicker(this.endDate)
    },

    startDateDisplay() {
      return this.$options.filters.formatDatePicker(this.startDate)
    },

    minAllowedEndDate() {
      return minAllowedPromotionEndDate(
        this.startDate,
        this.tenantCountryRegion
      )
    },

    minAllowedStartDate() {
      return minAllowedPromotionStartDate(this.tenantCountryRegion)
    },

    upcomingPriceChangeProductCodes() {
      return buildUpcomingPriceChangeProductCodeSet(
        this.products,
        this.familyGroups
      )
    },

    listFamilyGroups() {
      return [
        ...this.familyGroups
          // filter out familyGroups without products
          .filter((f) => f.productCodes.length)
          .map((f) =>
            withUpcomingPriceChangeDisabled(
              { text: f.name, value: f.id },
              familyGroupHasUpcomingPriceChange(
                f,
                this.upcomingPriceChangeProductCodes
              )
            )
          )
          .sort((p1, p2) => (p1.text < p2.text ? -1 : 1))
      ]
    },

    listProducts() {
      return [
        ...this.productsForSelection
          // filter out products that are not LIVE
          .filter((p) => p.status === 'LIVE')
          .map((p) => ({
            text: `${p.supplierItemId} / ${p.tradeItemDescription}`,
            value: p.productCode,
            disabled: p.disabled
          }))
          .map((option) =>
            withUpcomingPriceChangeDisabled(
              option,
              productHasUpcomingPriceChange(
                this.productsForSelection.find(
                  (product) => product.productCode === option.value
                ),
                this.familyGroups,
                this.upcomingPriceChangeProductCodes
              )
            )
          )
          .sort((p1, p2) => (p1.text < p2.text ? -1 : 1))
      ]
    },

    productsForSelection() {
      if (
        !this.selectedProductSnapshot ||
        this.products.some(
          (product) =>
            product.productCode === this.selectedProductSnapshot.productCode
        )
      ) {
        return this.products
      }

      return [...this.products, this.selectedProductSnapshot]
    },

    visibleProducts() {
      return buildVisibleProductOptions({
        options: this.listProducts,
        searchTerm: this.productSearchInput,
        selectedValues: this.selectedProduct ? [this.selectedProduct] : [],
        getSelectedValue: (selected) => selected
      })
    },

    selectedFamilyGroupLabel() {
      return this.listFamilyGroups.find(
        (familyGroup) => familyGroup.value === this.selectedFamilyGroup
      ).text
    },

    selectedProductLabel() {
      const selectedProduct = this.listProducts.find(
        (product) => product.value === this.selectedProduct
      )

      return selectedProduct?.text || this.selectedProduct
    },

    showUnavailableProductAlert() {
      return (
        this.newPromotion &&
        (this.listProducts.some((product) => product.disabled) ||
          this.listFamilyGroups.some((familyGroup) => familyGroup.disabled))
      )
    },

    // ***
    // Properties related to Volume Buy validation
    // ***

    unsavedTiersQuantity() {
      return VolumePromotionHelper.unsavedTiersQuantity(this.zonePrices)
    },

    hasUnsavedTiers() {
      return VolumePromotionHelper.hasUnsavedTiers(this.zonePrices)
    },

    hasValidTier() {
      return VolumePromotionHelper.hasValidTier(this.zonePrices)
    },

    hasPersistedTier() {
      return this.volumePromotion?.zonePrices?.some(
        (zone) => zone.tiers?.length
      )
    },

    hasValidTierForUpdate() {
      return (
        this.hasValidTier || (this.activePromotion && this.hasPersistedTier)
      )
    },

    validDates() {
      return this.startDate && this.endDate >= this.startDate
    },

    validPromotionSelection() {
      return !!this.selectedFamilyGroup || !!this.selectedProduct
    },

    validPromotionName() {
      if (!this.promotionName) return false

      return (
        this.promotionName.length <= 60 ||
        (!this.newPromotion &&
          this.promotionName === this.volumePromotion?.name)
      )
    },

    validTargetType() {
      return (
        (this.targetType === this.BANNER_GROUP &&
          !!this.targetBannerGroupIds.length) ||
        (this.targetType === this.MULTI_STORE_OPERATOR &&
          !!this.targetMultiStoreOperatorIds.length) ||
        (this.targetType === this.RETAILER_STORE &&
          !!this.targetStoreIds.length) ||
        this.targetType === this.NATIONAL
      )
    },

    variableWeightProductSelected() {
      return !!this.selectedProductData?.variableWeightTargetInKg
    },

    selectedProductData() {
      if (!this.selectedProduct) return null
      if (!this.newPromotion && this.productPromotion) {
        return this.volumePromotion.product
      }
      return (
        this.products.find((p) => p.productCode === this.selectedProduct) ||
        (this.selectedProductSnapshot?.productCode === this.selectedProduct
          ? this.selectedProductSnapshot
          : null)
      )
    },

    lockedProductLabel() {
      return `${this.volumePromotion.product.supplierItemId} / ${this.volumePromotion.product.tradeItemDescription}`
    },

    lockedFamilyGroupLabel() {
      return this.volumePromotion.familyGroup.name
    },

    isServiceProductSelected() {
      return this.selectedProductData?.productType === 'SERVICE'
    },
    displayRules() {
      return buildCountryDisplayRules(this.tenantCountryRegion)
    },
    isUsTenant() {
      return this.displayRules.isUSCountry
    },
    filteredZonePrices() {
      const term = (this.zoneFilter || '').trim().toLowerCase()
      if (!term) return this.zonePrices
      return this.zonePrices.filter((zone) => {
        const values = [zone.code, zone.name, zone.displayName, zone.state]
          .filter(Boolean)
          .map((v) => String(v).toLowerCase())
        return values.some((v) => v.includes(term))
      })
    },

    validPromotion() {
      return (
        (this.changesMade ||
          this.volumePromotion?.approval?.status === 'REJECTED') &&
        this.validPromotionName &&
        this.startDate &&
        this.endDate &&
        this.hasValidTierForUpdate &&
        this.validDates &&
        this.validPromotionSelection &&
        this.validPromotionProductAvailability &&
        this.validTargetType
      )
    },

    validPromotionProductAvailability() {
      if (!this.newPromotion) return true

      const selectedProduct = this.selectedProductData
      const selectedFamilyGroup = this.familyGroups.find(
        (familyGroup) => familyGroup.id === this.selectedFamilyGroup
      )

      return (
        !productHasUpcomingPriceChange(
          selectedProduct,
          this.familyGroups,
          this.upcomingPriceChangeProductCodes
        ) &&
        !familyGroupHasUpcomingPriceChange(
          selectedFamilyGroup,
          this.upcomingPriceChangeProductCodes
        )
      )
    }
  },

  watch: {
    discountEntryMode(newMode, oldMode) {
      if (oldMode && newMode !== oldMode) {
        this.clearDiscountPricing()
      }
    },

    productSearchInput(value) {
      if (this.promotionType !== this.SINGLE_PRODUCT) return
      this.$emit('search-products', value || '')
    }
  },

  methods: {
    ...mapActions('notifications', ['addNotification']),

    // ***
    // Functions related to help determining if Volume has been modified
    // ***
    createBluePrint() {
      return {
        promotionType: this.promotionType,
        selectedFamilyGroup: this.selectedFamilyGroup,
        selectedProduct: this.selectedProduct,
        promotionName: this.promotionName,
        startDate: this.startDate,
        endDate: this.endDate,
        targetBannerGroupIds: this.targetBannerGroupIds,
        targetMultiStoreOperatorIds: this.targetMultiStoreOperatorIds,
        targetStoreIds: this.targetStoreIds,
        targetType: this.targetType,
        zonePrices: this.zonePrices
      }
    },

    // ***
    // Functions related to pricemap
    // ***
    addPromotionZonePrices(zonePrices, promotionZonePrices) {
      return zonePrices.map((zone) => {
        return {
          ...zone,
          tiers:
            promotionZonePrices.find(
              (promo) => promo.pricingRegionCode === zone.code
            )?.tiers || []
        }
      })
    },

    handleFamilyGroupSelection() {
      if (!this.selectedFamilyGroup) {
        this.zonePrices = []
        this.promotionName = ''
        return
      }

      const familyGroup = this.familyGroups.find(
        ({ id }) => id === +this.selectedFamilyGroup
      )

      if (
        familyGroupHasUpcomingPriceChange(
          familyGroup,
          this.upcomingPriceChangeProductCodes
        )
      ) {
        this.selectedFamilyGroup = null
        this.zonePrices = []
        this.promotionName = ''
        return
      }

      this.promotionName = `${familyGroup.name}`

      // Required info to calculate GP%
      this.setGPPInfo(familyGroup)

      const regionalPriceMap =
        VolumePromotionHelper.transformFamilyGroupZonePricesToRegionalPriceMap(
          familyGroup.zonePrices,
          this.pricingRegions,
          this.tenantCountryRegion
        )
      const referenceProduct = this.getReferenceFamilyGroupProduct(
        familyGroup.productCodes
      )
      this.zonePrices = this.enrichWithOriginalProductRrp(
        regionalPriceMap,
        referenceProduct
      )
    },

    handleProductSelection() {
      if (!this.selectedProduct) {
        this.selectedProductSnapshot = null
        this.zonePrices = []
        this.promotionName = ''
        return
      }

      const product = this.selectedProductData

      if (!product) {
        this.zonePrices = []
        return
      }

      this.selectedProductSnapshot = product

      if (
        productHasUpcomingPriceChange(
          product,
          this.familyGroups,
          this.upcomingPriceChangeProductCodes
        )
      ) {
        this.selectedProduct = null
        this.selectedProductSnapshot = null
        this.zonePrices = []
        this.promotionName = ''
        return
      }

      this.promotionName = `${product.tradeItemDescription}`

      // Required info to calculate GP%
      this.setGPPInfo(product)

      this.zonePrices =
        VolumePromotionHelper.transformProductZonePricesToRegionalPriceMap(
          product.zoneCodesWithPrice,
          product.regionalPriceMap,
          this.tenantCountryRegion
        )
    },

    handleProductChange() {
      this.handleProductSelection()
      this.productSearchInput = ''
    },

    clearSelectedProduct() {
      this.selectedProduct = null
      this.selectedProductSnapshot = null
      this.productSearchInput = ''
      this.zonePrices = []
      this.$emit('search-products', '')
    },

    enrichWithOriginalProductRrp(regionalPriceMap, referenceProduct) {
      return regionalPriceMap.map((zone) => ({
        ...zone,
        originalUnitRrp:
          zone.originalUnitRrp ||
          referenceProduct?.regionalPriceMap?.[zone.code]?.[0]?.rrp ||
          null
      }))
    },

    getReferenceFamilyGroupProduct(productCodes = []) {
      const familyProducts = this.products.filter((p) =>
        productCodes.includes(p.productCode)
      )
      if (!familyProducts.length) return null

      const lowestPackageQuantity = Math.min(
        ...familyProducts.map((product) => Number(product.packageQuantity || 0))
      )
      return (
        familyProducts.find(
          (product) =>
            Number(product.packageQuantity || 0) === lowestPackageQuantity
        ) || null
      )
    },

    setGPPInfo(selection) {
      this.hasGst = selection.hasGst
      this.hasWet = selection.hasWet
      this.packageQuantity = selection.packageQuantity
      this.variableWeightTargetInKg = selection.variableWeightTargetInKg
    },

    zonesWithTiers(zone) {
      return zone.tiers.length
    },

    persistedPromotionZonePrices() {
      return (this.volumePromotion.zonePrices || []).map((zone) => {
        const pricingRegion = this.pricingRegions.find(
          (region) => region.code === zone.pricingRegionCode
        )

        return {
          ...zone,
          code: zone.pricingRegionCode,
          name: pricingRegion?.name,
          displayName: formatRegionDisplayName(
            pricingRegion,
            this.tenantCountryRegion
          ),
          newTier: { ...DEFAULT_PROMOTION_TIER }
        }
      })
    },

    zonePricesForSave() {
      if (this.activePromotion && !this.hasValidTier && this.hasPersistedTier) {
        return this.persistedPromotionZonePrices()
      }

      return this.zonePrices
    },

    // ***
    // Functions related to Special actions
    // ***

    copyVolumePromotion() {
      const savedPromotionName = this.volumePromotion.name

      this.promotionType = this.volumePromotion.volumePromotionType
      this.selectedFamilyGroup = this.volumePromotion.familyGroup?.id
      this.selectedProduct = this.volumePromotion.productCode
      this.startDate = this.volumePromotion.startDate
      this.endDate = this.volumePromotion.endDate

      this.targetBannerGroupIds =
        this.volumePromotion.targetBannerGroups?.map(
          (bannerGroup) => bannerGroup.bannerGroupId
        ) || []
      this.targetMultiStoreOperatorIds =
        this.volumePromotion.targetMultiStoreOperators?.map(
          (mso) => mso.multiStoreOperatorId
        ) || []
      this.targetStoreIds = this.volumePromotion.targetStores?.map(
        (store) => store.storeId
      )
      this.targetType = this.determineTargetType()

      this.selectedFamilyGroup
        ? this.handleFamilyGroupSelection()
        : this.handleProductSelection()
      this.promotionName = savedPromotionName

      this.zonePrices = this.zonePrices.length
        ? this.addPromotionZonePrices(
            this.zonePrices,
            this.volumePromotion.zonePrices
          )
        : this.persistedPromotionZonePrices()
      if (this.activePromotion)
        this.zonePrices = this.zonePrices.filter((zone) =>
          this.zonesWithTiers(zone)
        )
    },

    confirmSaveVolumePromotion() {
      this.saveVolumePromotion()
      this.unsavedTiersDialog = false
    },

    handleSaveVolumePromotion() {
      // If has unsaved Tiers show dialog warning user
      this.hasUnsavedTiers
        ? (this.unsavedTiersDialog = true)
        : this.saveVolumePromotion()
    },

    saveVolumePromotion() {
      this.saving = true

      const payload = {
        productCode: this.selectedProduct,
        familyGroupId: this.selectedFamilyGroup,
        startDate: this.startDate,
        endDate: this.endDate,
        name: this.promotionName,
        targetBannerGroupIds: this.targetBannerGroupIds,
        targetMultiStoreOperatorIds: this.targetMultiStoreOperatorIds,
        targetStoreIds: this.targetStoreIds,
        zonePrices: VolumePromotionHelper.mappedForAPI(
          this.zonePricesForSave(),
          this.isServiceProductSelected
        )
      }

      this.newPromotion
        ? this.createVolumePromotion(payload)
        : this.updateVolumePromotion(payload)
    },

    createVolumePromotion(volumePromotion) {
      createVolumePromotion(this.selectedSupplierId, volumePromotion)
        .then(() => {
          this.addNotification({
            color: 'secondary',
            text: 'Volume Buy has been created!'
          })
          this.$emit('save')
        })
        // Pending to add error handling based on Error code
        .catch((err) => {
          this.saving = false
          this.handleBackendError(err)
        })
    },

    updateVolumePromotion(volumePromotion) {
      updateVolumePromotion(
        this.selectedSupplierId,
        this.volumePromotion.id,
        volumePromotion
      )
        .then(() => {
          this.addNotification({
            color: 'secondary',
            text: 'Volume Buy has been updated!'
          })
          this.$emit('save')
        })
        // Pending to add error handling based on Error code
        .catch((err) => {
          this.saving = false
          this.handleBackendError(err)
        })
    },

    handleBackendError(err) {
      let msg
      switch (err.response?.data?.code || 'UNKNOWN_ERROR') {
        case 'VOLUME_PROMOTION_OVERLAP':
          msg =
            'There is an active Volume Buy for this product or family group on these dates...'
          break
        case 'UPCOMING_PRICE_RELATED_CHANGE_BEFORE_PROMOTION_END_DATE':
          msg =
            'Price related product edits exist before this Promotion ends. End Promotion before or delete upcoming product edits.'
          break
        default:
          msg = 'Volume Buy could not be created / updated, please try again...'
      }
      this.addNotification({ color: 'error', text: msg, timeout: -1 })
    },

    // ***
    // Functions related data mapping
    // ***

    mapBannerGroupsList() {
      // Map property names so that it works with V-select component
      this.targetBannerGroups = this.bannerGroups
        .map((bannerGroup) => ({
          text: bannerGroup.displayName,
          value: bannerGroup.id
        }))
        .sort((a, b) => (a.text > b.text ? 1 : -1))
    },

    mapMultiStoreOperatorsList() {
      // Map property names so that it works with V-select component
      this.targetMultiStoreOperators = this.multiStoreOperators
        .map((mso) => ({
          text: mso.displayName,
          value: mso.id
        }))
        .sort((a, b) => (a.text > b.text ? 1 : -1))
    },

    mapStoresList() {
      if (this.retailerStores?.length > 0) {
        // Map property names so that it works with V-select component
        this.targetStores = this.retailerStores
          .map((store) => ({
            ...store,
            text: store.displayName,
            value: store.id
          }))
          .sort((a, b) => (a.text > b.text ? 1 : -1))

        if (this.regionalPriceMap?.length) {
          // Filter out stores not located in regions where the product is available
          this.targetStores = this.targetStores.filter((store) =>
            this.regionalPriceMap
              .map((p) => p.code)
              .includes(store.pricingRegionCode)
          )
        }
      } else {
        this.addNotification({
          color: 'secondary',
          text: `Available ${
            this.isILR ? 'Customers' : 'Retailers'
          } loading, please wait...`
        })
      }
    },

    // ***
    // Helper Functions
    // ***

    determineTargetType() {
      if (
        Array.isArray(this.targetBannerGroupIds) &&
        this.targetBannerGroupIds.length
      )
        return this.BANNER_GROUP
      if (
        Array.isArray(this.targetMultiStoreOperatorIds) &&
        this.targetMultiStoreOperatorIds.length
      )
        return this.MULTI_STORE_OPERATOR
      if (Array.isArray(this.targetStoreIds) && this.targetStoreIds.length)
        return this.RETAILER_STORE
      return this.NATIONAL
    },

    resetTargetTypeForm() {
      this.targetBannerGroupIds = []
      this.targetMultiStoreOperatorIds = []
      this.targetStoreIds = []
    },

    resetPromotionForm() {
      this.selectedProduct =
        this.selectedFamilyGroup =
        this.targetType =
        this.promotionName =
        this.hasGst =
        this.hasWet =
        this.packageQuantity =
        this.variableWeightTargetInKg =
          null
      this.selectedProductSnapshot = null
      this.zonePrices = []
      this.resetTargetTypeForm()
      Object.keys(PROMOTION_FIELDS).forEach((key) => {
        if (key === 'targetType') {
          if (this.newPromotion) {
            this.targetType = this.NATIONAL
          }
        } else {
          this[key] = PROMOTION_FIELDS[key]
        }
      })
    },

    handleApplySavedRetailers(ids) {
      this.targetStoreIds = [...ids]
      this.savedListApplied = true
    },

    resetRetailers() {
      this.targetStoreIds = []
      this.savedListApplied = false
    },
    onUpdateAmountOff(value) {
      this.zonePrices.forEach((zone) => {
        zone.newTier.amountOff = value
        setDiscountPercentageFromAmountOff(
          zone.newTier,
          zone.cartonPrice,
          value
        )
        this.calculatePricing(zone)
      })
      this.validateTiers()
    },

    onUpdateDiscountPercentage(value) {
      this.zonePrices.forEach((zone) => {
        zone.newTier.discountPercentage = value
        zone.newTier.amountOff = amountOffFromDiscountPercentage(
          zone.cartonPrice,
          value
        )
        this.calculatePricing(zone)
      })
      this.validateTiers()
    },

    onUpdateUnitRrp(value) {
      if (this.isServiceProductSelected) return

      this.zonePrices.forEach((zone) => {
        zone.newTier.unitRrp = value
        this.calculatePricing(zone)
      })
    },

    onUpdateCartons(value) {
      this.zonePrices.forEach((zone) => {
        zone.newTier.numberOfCartons = value
        this.calculatePricing(zone)
      })
    },

    clearDiscountPricing() {
      this.zonePrices.forEach((zone) => {
        zone.tiers = []
        zone.newTier = { ...DEFAULT_PROMOTION_TIER }
      })
      this.validateTiers()
    },

    isZoneNewTierValid(zone) {
      if (!this.isServiceProductSelected && !this.isUsTenant) {
        return VolumePromotionHelper.isZoneNewTierValid(zone)
      }

      const newTierCartons = Number(zone.newTier.numberOfCartons)
      const newAmountOff = Number(zone.newTier.amountOff)

      const sortedTiers = [...zone.tiers].sort(
        (a, b) => a.numberOfCartons - b.numberOfCartons
      )
      const lowerTier = sortedTiers
        .filter((tier) => tier.numberOfCartons < newTierCartons)
        .pop()
      const higherTier = sortedTiers.find(
        (tier) => tier.numberOfCartons > newTierCartons
      )

      const respectsLowerTier =
        !lowerTier || newAmountOff >= Number(lowerTier.amountOff)
      const respectsHigherTier =
        !higherTier || newAmountOff <= Number(higherTier.amountOff)

      return (
        [zone.newTier.numberOfCartons, zone.newTier.amountOff].every(
          (value) => Number(value) > 0
        ) &&
        zone.newTier.amountOff <= zone.cartonPrice &&
        !zone.tiers.find((tier) => tier.numberOfCartons === newTierCartons) &&
        respectsLowerTier &&
        respectsHigherTier
      )
    },
    addAllTiers() {
      if (
        this.$refs.volumeTiersRef &&
        typeof this.$refs.volumeTiersRef.addAllEligibleTiers === 'function'
      ) {
        this.$refs.volumeTiersRef.addAllEligibleTiers()
      }
    },

    calculatePricing(zone) {
      if (
        this.$refs.volumeTiersRef &&
        typeof this.$refs.volumeTiersRef.calculatePricingForTier === 'function'
      ) {
        this.$refs.volumeTiersRef.calculatePricingForTier(
          zone.newTier,
          zone,
          zone.cartonPrice
        )
      }
    },

    validateTiers() {
      this.$nextTick(() => {
        if (
          this.$refs.volumeTiersRef &&
          typeof this.$refs.volumeTiersRef.validateAllTiers === 'function'
        ) {
          this.$refs.volumeTiersRef.validateAllTiers(
            this.$refs.volumeTiersRef.$refs
          )
        }
      })
    },

    handleTierAdded() {
      if (this.$refs.updateAllZones && this.$refs.updateAllZones.resetFields) {
        this.$refs.updateAllZones.resetFields()
      }
    },

    getFamilyGroupProductsById(familyGroupId) {
      if (!familyGroupId) return []

      const group = this.familyGroups.find((f) => f.id === familyGroupId)
      if (!group || !group.productCodes?.length) return []

      return group.productCodes
        .map((code) => {
          const product = this.products.find((p) => p.productCode === code)
          return product ? product.tradeItemDescription : null
        })
        .filter(Boolean)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

#edit-volume-promotion {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  box-shadow: none;
  background: $bg-secondary-color;
  .v-card__text {
    flex-grow: 1;
    overflow: auto;
  }
}
.v-tooltip__content {
  background-color: #2e2e2e !important;
  color: #fff !important;
}
.v-autocomplete__content .v-subheader {
  background: var(--v-secondary-lighten1);
  font-weight: bold;
  font-style: italic;
}

@media only screen and (min-width: 960px) {
  #edit-volume-promotion {
    th span {
      font-size: 14px;
    }
  }
}
</style>
